import { useCallback } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { useAppActions, useNav } from '../../AppContext'
import { ICON_SM } from '../../common/theme'
import iconScoreFix from '../../img/dashboard_2328909.png'
import type { Question } from '../../types'

interface Props {
  question: Question
  testId?: string
}

// "Open in Score & Fix" affordance — switches the active tab to the
// bideval view and sets the focused question. Reused by BidQuestion
// and BidQuestionScoring so the icon + behaviour stay in one place.
export default function OpenInScoreFixButton({ question, testId }: Props) {
  const { setCurrentQuestion } = useAppActions()
  const { setActiveTab } = useNav()
  const handleClick = useCallback(() => {
    setCurrentQuestion(question)
    setActiveTab('bideval')
  }, [question, setCurrentQuestion, setActiveTab])
  return (
    <Tooltip title="Open in Score & Fix">
      <IconButton size="small" onClick={handleClick} sx={{ p: 0.375 }} data-testid={testId}>
        <img src={iconScoreFix} alt="Score & Fix" style={{ width: ICON_SM, height: ICON_SM }} />
      </IconButton>
    </Tooltip>
  )
}
